import { render } from "./PromoFacebook.vue?vue&type=template&id=eb3ca228&scoped=true"
import script from "./PromoFacebook.vue?vue&type=script&lang=js"
export * from "./PromoFacebook.vue?vue&type=script&lang=js"

import "./PromoFacebook.vue?vue&type=style&index=0&id=eb3ca228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb3ca228"]])

export default __exports__